import { render, staticRenderFns } from "./BanWowStreamer.vue?vue&type=template&id=390d5611&scoped=true"
import script from "./BanWowStreamer.vue?vue&type=script&lang=js"
export * from "./BanWowStreamer.vue?vue&type=script&lang=js"
import style0 from "./BanWowStreamer.vue?vue&type=style&index=0&id=390d5611&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390d5611",
  null
  
)

export default component.exports